import { render, staticRenderFns } from "./TextContainer.vue?vue&type=template&id=170a45ae&scoped=true&"
import script from "./TextContainer.vue?vue&type=script&lang=js&"
export * from "./TextContainer.vue?vue&type=script&lang=js&"
import style0 from "./TextContainer.vue?vue&type=style&index=0&id=170a45ae&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170a45ae",
  null
  
)

export default component.exports